export enum HelpdeskModuleTags {
  knowledgebase = 'knowledgebase',
  documentation = 'documentation',
  templates = 'templates',
  redirects = 'redirects',
}

export const HELPDESK_TAGS = [HelpdeskModuleTags.knowledgebase, HelpdeskModuleTags.documentation, HelpdeskModuleTags.templates];
